

export default function useUiScroller(){

  const getNumberOfWeeks = (daysInMonth,firstDayOfMonth) => {
    const firstDayOfWeek = firstDayOfMonth.getDay() === 0 ? 7 : firstDayOfMonth.getDay();
    return Math.ceil((firstDayOfWeek + daysInMonth - 1) / 7);
  }

  const getMonthForDate = (currentDate,i) => {
    return new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + i,
        1
      );
  }

  const getDaysInMonth = (currentDate,i) => {
    return new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + i + 1,
        0
      ).getDate();
  }

  const calculatePositionForFirstMonthIfLimit = (minYear,currentDate) => {
    let totalHeight = 0;
    const start = new Date(minYear, 0); // This represents January of minYear
    let numberOfMonthsBeforeTheCurrentUntilJanuaryOfMinYear = (currentDate.getFullYear() - start.getFullYear()) * 12;
    numberOfMonthsBeforeTheCurrentUntilJanuaryOfMinYear -= start.getMonth();
    numberOfMonthsBeforeTheCurrentUntilJanuaryOfMinYear += currentDate.getMonth();
    numberOfMonthsBeforeTheCurrentUntilJanuaryOfMinYear = numberOfMonthsBeforeTheCurrentUntilJanuaryOfMinYear * -1;
    for (let i = numberOfMonthsBeforeTheCurrentUntilJanuaryOfMinYear; i < 0; i++) {
      const month = getMonthForDate(currentDate,i);
      const daysInMonth = getDaysInMonth(currentDate,i);
      const numberOfWeeks = getNumberOfWeeks(daysInMonth,month);
      const monthHeight = calculateMonthHeigth(numberOfWeeks);
      totalHeight += monthHeight;
    }
    return totalHeight*-1;
  }

  const calculatePositionForLastMonthIfLimit = (maxYear,currentDate) => {
    const end = new Date(maxYear, 11); // This represents December of maxYear
    let diffInMonths = (end.getFullYear() - currentDate.getFullYear()) * 12;
    diffInMonths -= currentDate.getMonth();
    diffInMonths += end.getMonth() + 1; // Add 1 because the month is zero-indexed
    diffInMonths = diffInMonths <= 0 ? 0 : diffInMonths;
    let totalHeight = 0;
    for (let i = 1; i <= diffInMonths; i++) {
      const month = getMonthForDate(currentDate,i);
      const daysInMonth = getDaysInMonth(currentDate,i);
      const numberOfWeeks = getNumberOfWeeks(daysInMonth,month);
      const monthHeight = calculateMonthHeigth(numberOfWeeks);
      totalHeight += monthHeight;
    }
    return totalHeight;
  }

  const calculatePositionsForCurrentMonths = (months) => {
    let yPosNegative = 0;
    let yPosPositive = 0;
    const negativeMonths = months.filter(el => el.index < 0);
    for (let i = negativeMonths.length - 1 ; i >= 0; i--) {
      const position = yPosNegative - calculateMonthHeigth(months[i].numberOfWeeks);
      months[i].yposition = position;
      yPosNegative = position;
    }
    for (let i = negativeMonths.length; i < months.length; i++) {
      months[i].yposition = yPosPositive;
      yPosPositive += calculateMonthHeigth(months[i].numberOfWeeks);
    }
    return months;
  }

  const HEIGTHOFROW = 42;
  const MARGINSBETWEENMONTHS = 70;
  const H2HEIGTH = 30;

  const calculateMonthHeigth = (numberOfWeeks) => {
    return (numberOfWeeks * HEIGTHOFROW + H2HEIGTH + MARGINSBETWEENMONTHS);
  }

  const YEARHEIGT = 585;

  const calculateYearsPositions = (years, initialYear) => {
    let yPosNegative = 0;
    let yPosPositive = 0;
    const indexInitial = years.findIndex(el => el.year == initialYear);
    const negativeYears = years.filter(el => el.year < years[indexInitial].year);
    for (let i = negativeYears.length - 1; i >= 0; i--) {
      const position = yPosNegative - YEARHEIGT;
      years[i].yposition = position;
      yPosNegative = position;
    }
    for (let i = negativeYears.length; i < years.length; i++) {
      years[i].yposition = yPosPositive;
      yPosPositive += YEARHEIGT;
    }
  }
  
  return {
    calculatePositionsForCurrentMonths,
    calculateYearsPositions,
    calculatePositionForFirstMonthIfLimit,
    calculatePositionForLastMonthIfLimit,
    calculateMonthHeigth
  }

}